import { FC, Fragment, JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
// components
import ProductIngredientTable from './ProductIngredientTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_NEW_TEXT, ADD_PRODUCT_INGREDIENT_ROUTE, PRODUCT_INGREDIENT_TEXT } from 'constants/index';

const ProductIngredient: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{PRODUCT_INGREDIENT_TEXT}</Typography>
        <Button variant="contained" color="primary" onClick={() => navigate(ADD_PRODUCT_INGREDIENT_ROUTE)}>
          <AddRoundedIcon />
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <ProductIngredientTable />
    </Fragment>
  );
};

export default ProductIngredient;
